import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAutoVehicle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#c1cdd1",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3846 6.38468L12.3675 3.66365C12.2713 3.35544 12.0989 3.08987 11.8734 2.90253C11.6478 2.71518 11.38 2.61502 11.1057 2.61545H4.89427C4.61999 2.61502 4.35215 2.71518 4.12663 2.90253C3.90112 3.08987 3.7287 3.35544 3.63247 3.66365L2.61538 6.38468",
			fill: "currentColor",
			fillOpacity: .25
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3846 6.38468L12.3675 3.66365C12.2713 3.35544 12.0989 3.08987 11.8734 2.90253C11.6478 2.71518 11.38 2.61502 11.1057 2.61545H4.89427C4.61999 2.61502 4.35215 2.71518 4.12663 2.90253C3.90112 3.08987 3.7287 3.35544 3.63247 3.66365L2.61538 6.38468",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.61538 11.2079V12.3078C2.61538 12.5934 2.72884 12.8673 2.9308 13.0693C3.13276 13.2712 3.40668 13.3847 3.6923 13.3847C3.97792 13.3847 4.25184 13.2712 4.4538 13.0693C4.65576 12.8673 4.76923 12.5934 4.76923 12.3078V11.2309",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3847 11.2079V12.3078C13.3847 12.5934 13.2712 12.8673 13.0692 13.0693C12.8673 13.2712 12.5934 13.3847 12.3077 13.3847C12.0221 13.3847 11.7482 13.2712 11.5462 13.0693C11.3443 12.8673 11.2308 12.5934 11.2308 12.3078V11.2309",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.24449 6.38467H13.7556C14.0856 6.38467 14.4022 6.53596 14.6356 6.80524C14.8689 7.07452 15 7.43975 15 7.82057V10.5129C15 10.7033 14.9345 10.8859 14.8178 11.0205C14.7011 11.1552 14.5428 11.2308 14.3778 11.2308H1.62227C1.45724 11.2308 1.29898 11.1552 1.18229 11.0205C1.0656 10.8859 1.00005 10.7033 1.00005 10.5129V7.82057C1.00005 7.43975 1.13116 7.07452 1.36454 6.80524C1.59791 6.53596 1.91444 6.38467 2.24449 6.38467Z",
			fill: "currentColor",
			fillOpacity: .25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.42317 9.07704C3.35176 9.07704 3.28328 9.04867 3.23279 8.99818C3.1823 8.94769 3.15394 8.87921 3.15394 8.8078C3.15394 8.7364 3.1823 8.66792 3.23279 8.61743C3.28328 8.56694 3.35176 8.53857 3.42317 8.53857",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.42316 9.07704C3.49456 9.07704 3.56304 9.04867 3.61353 8.99818C3.66402 8.94769 3.69239 8.87921 3.69239 8.8078C3.69239 8.7364 3.66402 8.66792 3.61353 8.61743C3.56304 8.56694 3.49456 8.53857 3.42316 8.53857",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5769 9.07704C12.5055 9.07704 12.4371 9.04867 12.3866 8.99818C12.3361 8.94769 12.3077 8.87921 12.3077 8.8078C12.3077 8.7364 12.3361 8.66792 12.3866 8.61743C12.4371 8.56694 12.5055 8.53857 12.5769 8.53857",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.577 9.07707C12.6484 9.07707 12.7169 9.0487 12.7674 8.99821C12.8178 8.94772 12.8462 8.87924 12.8462 8.80784C12.8462 8.73643 12.8178 8.66795 12.7674 8.61746C12.7169 8.56697 12.6484 8.5386 12.577 8.5386",
			stroke: "currentColor"
		})
	]
});
export default SvgAutoVehicle;
